export const playList = [
  {
    name: 'PLO Man - CESAR35_side A',
    writer: '',
    img: 'https://i1.sndcdn.com/artworks-FzfdPcoDFomYJ8J0-uC9QJA-t500x500.jpg',
    src: 'https://profoundbathroomgraf.s3.ap-southeast-2.amazonaws.com/CESAR35++_+side+A.mp3',
    id: 1,
  },
  {
    name: 'PLO Man - CESAR35_side B',
    writer: '',
    img: 'https://i1.sndcdn.com/artworks-FzfdPcoDFomYJ8J0-uC9QJA-t500x500.jpg',
    src: 'https://profoundbathroomgraf.s3.ap-southeast-2.amazonaws.com/CESAR35+_+side+B.mp3',
    id: 2,
  },
  {
    name: 'Anthony Naples - Beats In Space - 12th August 2015 ',
    writer: '',
    img: 'https://beatsinspace.net/wp-content/uploads/2018/11/anthonynaples.jpg',
    src: 'https://episodes.castos.com/beatsinspace/bis-12-08-15-part1.mp3',
    id: 3,
  },
  {
    name: 'PLO Man Cashmere Radio',
    writer: '',
    img: 'https://media.cashmereradio.com/wp-content/uploads/2020/02/23040854/photo_2020-02-06_13.24.03.jpeg',
    src: 'https://profoundbathroomgraf.s3.ap-southeast-2.amazonaws.com/Cashmere+42+PLOMAN.m4a',
    id: 4,
  },
  {
    name: 'Theejjonaz mix - Irdial Discs',
    writer: '',
    img: 'https://i.ebayimg.com/images/g/d8kAAOSwUYhhr5JD/s-l500.jpg',
    src: 'https://profoundbathroomgraf.s3.ap-southeast-2.amazonaws.com/theejjonaz.m4a',
    id: 5,
  },
  {
    name: 'Olly Chubb - Steve Rachmad Tribute Show',
    writer: '',
    img: 'https://i.ebayimg.com/images/g/d8kAAOSwUYhhr5JD/s-l500.jpg',
    src: 'https://profoundbathroomgraf.s3.ap-southeast-2.amazonaws.com/Circuits+w_+Olly+Chubb_+Steve+Rachmad+Special+240522.mp3',
    id: 6,
  },
]
